import React from 'react';

const SidebarHeader = ({ themeMode, onToggleTheme }) => {
    return (
        <div className="sidebar-header">
            <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                marginBottom: '20px' 
            }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                    <h3 style={{ margin: 0 }}>Construction Brain</h3>
                    <span className="powered-by">Powered by Propagile</span>
                </div>
                <button
                    onClick={onToggleTheme}
                    className="theme-toggle-btn"
                    title={themeMode === 'dark' ? "Switch to light mode" : "Switch to dark mode"}
                    aria-label={themeMode === 'dark' ? "Switch to light mode" : "Switch to dark mode"}
                >
                    {themeMode === 'dark' ? 
                        <i className="bi bi-sun-fill"></i> : 
                        <i className="bi bi-moon-stars-fill"></i>
                    }
                </button>
            </div>
        </div>
    );
};

export default React.memo(SidebarHeader);